export default area => area.title + (area.subtitle ? ` ${area.subtitle}` : '');
